import React, { useState } from "react";
import "../styles/Demo.css";
import CountUp from "react-countup";
import { CircularProgress } from "@mui/material";
import TextAnimator from "./TextAnimator";

const GoalsSection = () => {
  const callData = [
    {
      species: "ppip",
      x: -20,
      y: -10,
      w: 60,
      h: 160,
    },
    {
      species: "nnoc",
      x: 65,
      y: 85,
      w: 105,
      h: 120,
    },
    {
      species: "ppip",
      x: 190,
      y: 10,
      w: 60,
      h: 150,
    },
    {
      species: "nnoc",
      x: 275,
      y: 85,
      w: 110,
      h: 120,
    },
    {
      species: "ppip",
      x: 400,
      y: -5,
      w: 60,
      h: 145,
    },
    {
      species: "nnoc",
      x: 485,
      y: 85,
      w: 125,
      h: 120,
    },
  ];
  const initialSpeciesData = {
    ppip: {
      name: "Pipistrellus pipistrellus",
      percentage: 70,
      confidence: 60,
      ranking: [
        { name: "Pipistrellus pygmeus", percentage: 20 },
        { name: "Pipistrellus kuhlii", percentage: 6 },
        { name: "Pipistrellus nathusii", percentage: 4 },
      ],
    },
    nnoc: {
      name: "Nyctalus noctula",
      percentage: 80,
      confidence: 90,
      ranking: [
        { name: "Pipistrellus leisleri", percentage: 15 },
        { name: "Verspertilius murinus", percentage: 5 },
      ],
    },
  };
  const updatedSpeciesData = {
    ppip: {
      name: "Pipistrellus pipistrellus",
      percentage: 85,
      confidence: 80,
      ranking: [
        { name: "Pipistrellus pygmeus", percentage: 10 },
        { name: "Pipistrellus kuhlii", percentage: 3 },
        { name: "Pipistrellus nathusii", percentage: 2 },
      ],
      similarities: [
        { image: "", name: "Pipistrellus pipistrellus", similarity: 96 },
        { image: "", name: "Pipistrellus pipistrellus", similarity: 93 },
      ],
      text: "Downward frequency-modulated sweep, clear resemblance of a 'hockey stick' peak frequency of 45 kHz, starting around 55 kHz and descending to 40 kHz. Well-defined on the spectrogram, most likely Pipistrellus pipistrellus.",
    },
    nnoc: {
      name: "Nyctalus noctula",
      percentage: 90,
      confidence: 98,
      ranking: [
        { name: "Nyctalus leisleri", percentage: 7 },
        { name: "Verspertilius murinus", percentage: 3 },
      ],
      similarities: [
        { image: "", name: "Nyctalus noctula", similarity: 93 },
        { image: "", name: "Nyctalus leisleri", similarity: 91 },
      ],
      text: "Broadband downward frequency-modulated sweep, transitioning into a quasi-constant frequency (QCF) phase. Peak frequency around 20–25 kHz, starting near 30–40 kHz and descending to 18–22 kHz. Most likely Nyctalus noctula.",
    },
  };
  const rankingOpacity = [0.7, 0.5, 0.4];

  const getConfidenceRating = (confidence) => {
    if (confidence <= 60) return "Unconfident";
    if (confidence <= 80) return "Fairly confident";
    return "Very confident";
  };

  const [selectedSpecies, setSelectedSpecies] = useState(null);
  const [contextPosition, setContextPosition] = useState({ x: 0, y: 0 });
  const [currentSpeciesData, setCurrentSpeciesData] =
    useState(initialSpeciesData);
  const [countup, setCountup] = useState(false);
  const [updated, setUpdated] = useState(false);
  const [updating, setUpdating] = useState(false);

  return (
    <section
      style={{ maxWidth: 600, margin: "auto" }}
      onMouseLeave={() => {
        setSelectedSpecies(null);
      }}
    >
      <h2 style={{ fontSize: 28, textAlign: "center" }}>Preview</h2>
      <div class="demo">
        <img src="call.svg" class="call" />
        {callData.map((call) => (
          <div
            class="call-rect"
            style={{
              top: call.y,
              left: call.x,
              width: call.w,
              height: call.h,
              opacity: selectedSpecies == call.species ? 1 : 0.3,
              borderColor:
                selectedSpecies == call.species ? "#c9179a" : "#6e3224",
            }}
            onMouseMove={() => {
              setSelectedSpecies(call.species);
              setContextPosition({ x: call.x + call.w, y: call.y + call.h });
            }}
          />
        ))}

        {selectedSpecies != null && (
          <div
            class="contextMenu"
            style={{
              top: contextPosition.y - 10,
              left: contextPosition.x - 10,
            }}
          >
            <div class="species">
              <span>
                <i>{currentSpeciesData[selectedSpecies].name}</i>
              </span>
              {countup ? (
                <CountUp
                  start={0}
                  end={currentSpeciesData[selectedSpecies].percentage}
                  duration={2}
                  useEasing
                  className="percentage"
                  suffix="%"
                />
              ) : (
                <span class="percentage">
                  {currentSpeciesData[selectedSpecies].percentage}%
                </span>
              )}
            </div>

            {currentSpeciesData[selectedSpecies].ranking.map((el, i) => (
              <div class="rankSpecies" style={{ opacity: rankingOpacity[i] }}>
                <span>
                  <i>{el.name}</i>
                </span>
                {countup ? (
                  <CountUp
                    start={0}
                    end={el.percentage}
                    duration={2}
                    useEasing
                    className="percentage"
                    suffix="%"
                  />
                ) : (
                  <span class="percentage">{el.percentage}%</span>
                )}
              </div>
            ))}

            <div class="confidence">
              <div class="progressbar">
                <div
                  class="progress"
                  style={{
                    width: currentSpeciesData[selectedSpecies].confidence + "%",
                  }}
                />
              </div>
              <span>
                {getConfidenceRating(
                  currentSpeciesData[selectedSpecies].confidence
                )}
              </span>
            </div>

            {updated ? (
              <div>
                <TextAnimator
                  key={selectedSpecies}
                  text={currentSpeciesData[selectedSpecies].text}
                  delay={100}
                  className="interpretation"
                  renderWord={(word, index) =>
                    word === "Pipistrellus" ||
                    word === "pipistrellus." ||
                    word === "Nyctalus" ||
                    word === "noctula." ? (
                      <b key={index}>
                        <i>{word} </i>
                      </b>
                    ) : (
                      word + " "
                    )
                  }
                />

                <div class="similarity-ranking">
                  <div style={{ marginBottom: 8 }}>
                    <span style={{ fontSize: 12 }}>Similar Calls</span>
                  </div>
                  {currentSpeciesData[selectedSpecies].similarities.map(
                    (el) => (
                      <div class="similarity">
                        <img
                          src={selectedSpecies + "_call.svg"}
                          style={{ width: 32, height: 32 }}
                        />
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span class="sim-name">
                            <i>{el.name}</i>
                          </span>
                          <span class="sim-sim">
                            {el.similarity}% similarity
                          </span>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            ) : (
              <button
                class="analysis-button"
                onClick={() => {
                  setUpdating(true);
                  setTimeout(() => {
                    setCurrentSpeciesData(updatedSpeciesData);
                    setUpdated(true);
                    setCountup(true);
                    setUpdating(false);
                    setTimeout(() => setCountup(false), 2000);
                  }, 3000);
                }}
              >
                {updating ? (
                  <CircularProgress color="secondary" size={16} />
                ) : (
                  <span>Deep Analysis</span>
                )}
              </button>
            )}
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          flexWrap: "wrap",
          marginTop: 84,
        }}
      >
        <div>
          <h2 style={{ fontSize: 22 }}>Our Goals</h2>
          <ul style={{ marginLeft: 16, marginTop: 8 }}>
            <li>State-of-the-Art accuracy</li>
            <li>Interpretability</li>
            <li>Learn from unlabeled data</li>
          </ul>
        </div>

        <div>
          <h2 style={{ fontSize: 22 }}>To Contributors</h2>
          <ul style={{ marginLeft: 16, marginTop: 8 }}>
            <li>Free access to the final model</li>
            <li>Public mention</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default GoalsSection;
